module.exports = __webpack_public_path__ + "Lato-Black.105525226deeee6696ff.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Black.ttf
// module id = ../../../../../src/assets/fonts/Lato-Black.ttf
// module chunks = styles